import { isObject } from '../../../shared/helpers/is-object';
import { IncomingEvents, IncomingPostMessage } from './types';

export function isIncomingPostMessage(value: unknown): value is IncomingPostMessage {
    if (!value || !isObject(value)) {
        return false;
    }

    return (
        'event' in value &&
        typeof value.event === 'string' &&
        Object.values(IncomingEvents).includes(value.event as IncomingEvents)
    );
}
